import imageDe from '../images/de/sensotrend_uploader_select_devices.png';
import imageEn from '../images/en/sensotrend_uploader_select_devices.png';
import imageEs from '../images/es/sensotrend_uploader_select_devices.png';
import imageFi from '../images/fi/sensotrend_uploader_select_devices.png';
import imageFr from '../images/fr/sensotrend_uploader_select_devices.png';
import imageIt from '../images/it/sensotrend_uploader_select_devices.png';
import imageNo from '../images/no/sensotrend_uploader_select_devices.png';
import imageSv from '../images/sv/sensotrend_uploader_select_devices.png';

export const uploaderSelectDevicesImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
